module.exports = __webpack_public_path__ + "fontawesome-webfont.b06871f281fee6b241d6.ttf";


//////////////////
// WEBPACK FOOTER
// E:/Git_new/IVMS_PRO/web/src/assets/icon/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = ../../../../../src/assets/icon/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module chunks = styles